import React from 'react';
import ConnectedAccountInputs from '../components/AccountInputs';
import Layout from '../components/Layout';
import AdsTitle from '../components/AdsTitle';
import accountTypes from '../constants/accountTypes';

const Ads = () => (
  <Layout
    title={<AdsTitle title="Let's Get Started" />}
    subtitle=""
  >
    <ConnectedAccountInputs accountType={accountTypes.ads} />
  </Layout>
);

export default Ads;



// WEBPACK FOOTER //
// ./src/pages/Ads.jsx